module.exports = __webpack_public_path__ + "advisory-8c397925/westend61-a35a9358c4fa2bf61295e722995289d7.jpg";